import { render, staticRenderFns } from "./UrunToplama.vue?vue&type=template&id=4952d880"
import script from "./UrunToplama.vue?vue&type=script&lang=js"
export * from "./UrunToplama.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports